import { Injectable } from '@angular/core';
import ApplicationSettings from '../../../types/application-settings/ApplicationSettings';
import ApplicationSettingsWriteDTO from '../../../types/application-settings/ApplicationSettingsWriteDTO';
import { BaseService } from './base.service';

@Injectable({
    providedIn: 'root'
})
export class ApplicationSettingsService {

    private RESOURCE: string = 'application-settings';

    constructor(private baseService: BaseService) {
    }

    /**
     * Gets the application settings from the backend.
     *
     * @return The application settings.
     */
    public async getApplicationSettings(): Promise<ApplicationSettings> {
        return await this.baseService.get<ApplicationSettings>(this.RESOURCE);
    }

    /**
     * Updates the application settings in the backend.
     *
     * @param applicationSettings The application settings to update.
     */
    public async updateApplicationSettings(applicationSettings: ApplicationSettingsWriteDTO): Promise<void> {
        await this.baseService.put(this.RESOURCE, applicationSettings);
    }
}
